const t = {
  styleOverrides: {
    root: ({ theme: r }) => ({
      ...r.typography.h6
    })
  }
};
export {
  t as avatar
};
//# sourceMappingURL=avatar.mjs.map
